export default {
    signature: {
        formProp: 'signature',
        form: {
            label: 'Enter your full name to digitally sign',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Full name...',
            value: ''
        },
        validation: [ 'regex:^[a-zA-Z\\s]*$:Only characters and spaces allowed.' ]
    },
    understandAndAgree: {
        formProp: 'understandAndAgree',
        form: {
            label: 'I understand and agree to the above',
            required: true
        },
        field: {
            size: 'small',
            checked: false
        },
        validation: [ 'bool:true:Please check to acknowledge.' ]
    },
    designeeLetter: {
        formProp: 'designeeLetter',
        form: {
            label: 'Designee Letter',
            required: true
        },
        field: {
            size: 'small',
            value: '',
            style: {
                width: '100%',
                height: '24px',
                fontSize: '12px'
            }
        },
        validation: ['object:File:Letter must be attached.',
                    'file-types:File:(.png,.jpg,.gif,.pdf)' ]
    }
}
